import { render } from "./TopSeries.vue?vue&type=template&id=1928e431&scoped=true"
import script from "./TopSeries.vue?vue&type=script&lang=js"
export * from "./TopSeries.vue?vue&type=script&lang=js"

import "./TopSeries.vue?vue&type=style&index=0&id=1928e431&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1928e431"]])

export default __exports__